import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-splash',
  standalone: true,
  imports: [],
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
  animations: [
    trigger('splashAnimation', [
      transition(':enter', [
        style({ opacity: 1 }),
        animate('0ms')
      ]),
      transition(':leave', [
        animate('500ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class SplashComponent implements OnInit, OnDestroy {
  private navigateTimeout: any;
  private wordmarkTimeout: any;
  private targetRoute: string = '/locations';
  showWordmark: boolean = false;
  logoMoved: boolean = false;
  logoVisible: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.logoVisible = true;  
    }, 100); 
    this.route.queryParams.subscribe(params => {
      const originalPath = params['originalPath'];
      const appointmentId = sessionStorage.getItem('appointmentId');

      if (originalPath?.includes('/getAppointment') || appointmentId) {
        this.targetRoute = '/getAppointment';
      } else {
        this.targetRoute = '/locations';      
      }
      this.wordmarkTimeout = setTimeout(() => {
        this.showWordmark = true;
        this.logoMoved = true;  
      }, 1500);

      this.navigateTimeout = setTimeout(() => {
        this.router.navigate([this.targetRoute], { replaceUrl: true });
      }, 4000);
    });
  }

  ngOnDestroy(): void {
    if (this.navigateTimeout) {
      clearTimeout(this.navigateTimeout);
    }
    if (this.wordmarkTimeout) {
      clearTimeout(this.wordmarkTimeout);
    }
  }
}
